enum FenetresAide {
  PremierAccesCiblerBienAVendre = 'premier-acces-cibler-bien-a-vendre',
}

export default FenetresAide
